// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".userList[data-v-01cc6738],.userList .el-tabs[data-v-01cc6738],.userList .el-tabs .el-table[data-v-01cc6738],.userList .el-tabs .el-table[data-v-01cc6738] .el-table__body-wrapper{width:1290px}.userList .el-tabs .el-table[data-v-01cc6738] td{padding:0;height:50px;line-height:50px}.userList .el-tabs .el-pagination.is-background[data-v-01cc6738]{margin:15px 0 0 0}", ""]);
// Exports
module.exports = exports;
